import * as i0 from '@angular/core';
import { Component, ViewChild, Input, NgModule } from '@angular/core';
import * as i3 from 'primeng/tooltip';
import { Tooltip, TooltipModule } from 'primeng/tooltip';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@pv-frontend/pv-shared-components/svg-icon';
import { SvgIconModule } from '@pv-frontend/pv-shared-components/svg-icon';
function CopyComponent_p_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p", 4);
    i0.ɵɵlistener("click", function CopyComponent_p_1_Template_p_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleClick());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(ctx_r1.style == null ? null : ctx_r1.style.label);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.label, " ");
  }
}
function CopyComponent_pv_svg_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "pv-svg-icon", 5);
    i0.ɵɵlistener("click", function CopyComponent_pv_svg_icon_2_Template_pv_svg_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleClick());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_1_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap((tmp_1_0 = ctx_r1.style == null ? null : ctx_r1.style.copyIconStyle) !== null && tmp_1_0 !== undefined ? tmp_1_0 : ctx_r1.iconStyle);
    i0.ɵɵproperty("name", ctx_r1.copyIcon);
  }
}
function CopyComponent_pv_svg_icon_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "pv-svg-icon", 6);
  }
  if (rf & 2) {
    let tmp_1_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap((tmp_1_0 = ctx_r1.style == null ? null : ctx_r1.style.successIconStyle) !== null && tmp_1_0 !== undefined ? tmp_1_0 : ctx_r1.iconStyle);
    i0.ɵɵproperty("name", ctx_r1.successIcon)("pTooltip", ctx_r1.successText)("tooltipPosition", ctx_r1.toolTipPosition)("tooltipDisabled", false);
  }
}
let CopyComponent = /*#__PURE__*/(() => {
  class CopyComponent {
    constructor() {
      this.showCopySuccessIcon = false;
      /**
       * To render the tooltip top | left | right | bottom positions
       */
      this.toolTipPosition = 'right';
      /**
       * One variant of tooltip where underline is shown below the label passed
       */
      this.label = '';
      /**
       * The value to be copied to the clipboard when the label/icon is clicked upon
       */
      this.valueToBeCopied = '';
      /**
       * The text to be shown in the tooltip when copy is successful
       */
      this.successText = 'Copied';
      /**
       * the default amount of time for which we will show the tooltip
       */
      this.delay = 800;
      /**
       * Icon to be used for copy
       */
      this.copyIcon = 'copy';
      /**
       * Icon to be used for copy
       */
      this.successIcon = 'tick';
      this.style = {};
      this.iconStyle = {
        fill: 'var(--primary-color)',
        height: '1rem',
        width: '1rem'
      };
    }
    isSecuredWindow() {
      return window.isSecureContext;
    }
    handleClick() {
      /**
       * Async clipboard isn't allowed in non-secure context
       * Reference - https://web.dev/async-clipboard/#security-and-permissions
       * Check if it is a secure context and then only proceed to write to clipboard
       */
      if (this.isSecuredWindow()) {
        navigator.clipboard.writeText(this.valueToBeCopied).then(() => {
          this.showCopySuccessIcon = true;
          // tooltip becomes available in dom once the success icon svg is rendered
          // hence schedule it via timeout and not in main thread
          setTimeout(() => this.tooltip?.show());
          // now revert back to copy icon after the delay
          setTimeout(() => this.showCopySuccessIcon = false, this.delay);
        }).catch(error => {
          // todo - integrate with error service in future
          console.error('something went wrong while copying ', error);
        });
      } else {
        // todo - integrate with error service in future
        console.error('copy not allowed in insecure window, please use HTTPS');
      }
    }
  }
  CopyComponent.ɵfac = function CopyComponent_Factory(t) {
    return new (t || CopyComponent)();
  };
  CopyComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CopyComponent,
    selectors: [["pv-copy"]],
    viewQuery: function CopyComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(Tooltip, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tooltip = _t.first);
      }
    },
    inputs: {
      toolTipPosition: "toolTipPosition",
      label: "label",
      valueToBeCopied: "valueToBeCopied",
      successText: "successText",
      delay: "delay",
      copyIcon: "copyIcon",
      successIcon: "successIcon",
      style: "style"
    },
    decls: 4,
    vars: 5,
    consts: [[1, "pv-copy-container", "flex", "surface-text-muted-low-contrast"], ["class", "m-0 text-base underline cursor-pointer pv-dotted-decoration", 3, "style", "click", 4, "ngIf"], ["styleClass", "cursor-pointer", 3, "name", "style", "click", 4, "ngIf"], ["styleClass", "cursor-pointer", "tooltipEvent", "focusout", 3, "name", "pTooltip", "tooltipPosition", "tooltipDisabled", "style", 4, "ngIf"], [1, "m-0", "text-base", "underline", "cursor-pointer", "pv-dotted-decoration", 3, "click"], ["styleClass", "cursor-pointer", 3, "click", "name"], ["styleClass", "cursor-pointer", "tooltipEvent", "focusout", 3, "name", "pTooltip", "tooltipPosition", "tooltipDisabled"]],
    template: function CopyComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, CopyComponent_p_1_Template, 2, 3, "p", 1)(2, CopyComponent_pv_svg_icon_2_Template, 1, 3, "pv-svg-icon", 2)(3, CopyComponent_pv_svg_icon_3_Template, 1, 6, "pv-svg-icon", 3);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵstyleMap(ctx.style == null ? null : ctx.style.container);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.label && !ctx.showCopySuccessIcon);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.label && !ctx.showCopySuccessIcon);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.showCopySuccessIcon);
      }
    },
    dependencies: [i1.NgIf, i2.SvgIconComponent, i3.Tooltip],
    encapsulation: 2
  });
  return CopyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PvCopyModule = /*#__PURE__*/(() => {
  class PvCopyModule {}
  PvCopyModule.ɵfac = function PvCopyModule_Factory(t) {
    return new (t || PvCopyModule)();
  };
  PvCopyModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: PvCopyModule
  });
  PvCopyModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule, SvgIconModule, TooltipModule]
  });
  return PvCopyModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { CopyComponent, PvCopyModule };
